<template>
  <header class="head">
    <div class="head__inner">
      <logo></logo>
    </div>
  </header>
</template>

<script>
  import Logo from './Logo';

  export default {
    components: {
      Logo,
    },
  }
</script>

<style lang="scss">
  @import 'scss/base';

  .head {
    display: flex;
    padding: 0;
    height: 40px;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 20;

    @media (max-width: 991px) {
      path {
        fill: $color-white !important;
      }
    }

    @media (min-width: 992px) {
      height: 54px;
      padding: 0;

      svg {
        height: 54px;
        width: 50px;
      }
    }

    &.is-dark path {
      fill: $color-black;
    }

    &.is-light path {
      fill: $color-white;
    }
  }

  .head__inner {
    text-align: center;
    width: 100%;

    @media #{$grid-lg-up} {
      padding: 0 15px;
    }
  }
</style>